import { render, staticRenderFns } from "./OutletCallCard.vue?vue&type=template&id=ca42a978"
import script from "./OutletCallCard.vue?vue&type=script&lang=js"
export * from "./OutletCallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports